export default __webpack_public_path__ + "static/CurriculumVitae-09b9524b86d35f31e712ff6a92c40207.pdf";